import React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const AlertWrapper = ({ type, message, onClose }: any) => {
    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                width: '100%',
                padding: '0 1rem',
                zIndex: 9999,
            }}
        >
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert
                    action={
                        <IconButton
                            aria-label='close'
                            color='inherit'
                            size='small'
                            onClick={onClose}
                        >
                            <CloseIcon fontSize='inherit' />
                        </IconButton>
                    }
                    sx={{ mb: 2 }}
                    severity={type}
                >
                    {message}
                </Alert>
            </Stack>
        </div>
    );
};

export default AlertWrapper;
